import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Invoice } from '../models/invoice';

@Injectable()
export class InvoiceService {
  private invoiceSource = new BehaviorSubject(new Invoice());
  currentInvoice = this.invoiceSource.asObservable();

  constructor() { }


  changeInvoice(newInvoice: Invoice) {
    this.invoiceSource.next(newInvoice);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/data.invoice.ts